export default __webpack_public_path__ + "static/media/gallery_06.57f548d9.jpg";